import * as React from 'react';
import { ISpinnerProps } from './ISpinnerProps';
import * as SpinnerState from 'Components/Spinner/ISpinnerState';

export class Spinner extends React.Component<ISpinnerProps, SpinnerState.ISpinnerState> {
  private showWaitDialogCallCount: number;

  constructor(props: ISpinnerProps) {
    super(props, undefined);
    this.state = { ...this.state, ...{ dialogOpen: false, initial: true } };
    this.showWaitDialogCallCount = 0;
    //this.props.spinnerEventHandler.subscribe = this.props.spinnerEventHandler
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    this.props.spinnerEventHandler.subscribe((sender, args) => {
      self.setState({ dialogOpen: !args.hideSpinner, initial: false });
    });
  }

  showLoadingWaitDialog(initialSpinner = false): void {
    if (!this.state.dialogOpen) {
      this.setState({ dialogOpen: true, initial: initialSpinner });
    }
    this.showWaitDialogCallCount++;
  }

  hideLoadingWaitDialog(): void {
    if (this.showWaitDialogCallCount === 0) {
      return;
    }
    if (this.showWaitDialogCallCount === 1) {
      this.setState({ dialogOpen: false, initial: false });
      this.showWaitDialogCallCount--;
    } else {
      this.showWaitDialogCallCount--;
    }
    return;
  }

  render() {
    let wrapperClasses = 'spinner-wrapper';
    if (this.state.dialogOpen) {
      wrapperClasses += ' display-block';
    }
    if (this.state.initial) {
      wrapperClasses += ' initial';
    }

    return (
      <div className={wrapperClasses} id="spinner-wrapper">
        <div className="fader"></div>
        <div className="spinner-content">
          <div className="loader-line-mask">
            <div className="loader-line"> </div>
          </div>
          <div className="tmlogo">
            <svg
              x="0px"
              y="0px"
              width="283.5px"
              height="26.7px"
              viewBox="0 0 283.5 26.7"
              xmlSpace="preserve"
            >
              <g id="Layer_1">
                <g id="XMLID_1_">
                  <polygon
                    id="XMLID_33_"
                    className="st1"
                    points="1.9,3 1.9,6.3 11.8,6.3 11.8,23.7 15.6,23.7 15.6,6.3 25.5,6.3 25.5,3"
                  />
                  <path
                    id="XMLID_30_"
                    className="st1"
                    d="M39.1,16h12.3c2.2,0,3.3,0.3,3.3,2.8v4.9h3.6v-5.6c0-1.7-0.6-2.9-1.9-3.6 c1.2-0.5,2.1-1.6,2.1-3.8V9.1c0-4-1.1-6.1-7.1-6.1H35.3v20.7h3.8V16z M39.1,6.3h11.4c4.1,0,4.2,0.8,4.2,2.3v1.8 c0,1.4-0.6,2.2-3.6,2.2H39.1V6.3z"
                  />
                  <path
                    id="XMLID_27_"
                    className="st1"
                    d="M74.3,19.6h15l2.4,4.1h4.4L83.8,3h-4L67.6,23.7h4.4L74.3,19.6z M76.3,16.2l5.5-9.4l5.5,9.4 H76.3z"
                  />
                  <polygon
                    id="XMLID_26_"
                    className="st1"
                    points="165.1,3.7 164.3,3 159.6,3 147.3,11.3 144.8,11.3 144.8,3 141,3 141,23.7 144.8,23.7 144.8,14.6 147.1,14.6 160.5,23.7 165.6,23.7 166.3,23 151.2,13"
                  />
                  <polygon
                    id="XMLID_25_"
                    className="st1"
                    points="191.7,18.9 180.5,3 175.5,3 175.5,23.7 179.3,23.7 179.3,7.7 190.4,23.7 192.9,23.7 204,7.7 204,23.7 207.8,23.7 207.8,3 202.8,3"
                  />
                  <path
                    id="XMLID_4_"
                    className="st1"
                    d="M229.4,3l-12.3,20.7h4.4l2.4-4.1h15l2.4,4.1h4.4L233.3,3H229.4z M236.9,16.2h-11.1l5.5-9.4L236.9,16.2z"
                  />
                  <polygon
                    id="XMLID_3_"
                    className="st1"
                    points="276.8,3 276.8,19.4 259.7,3 254.9,3 254.9,23.7 258.8,23.7 258.8,7.3 275.8,23.7 280.6,23.7 280.6,3"
                  />
                  <path
                    id="XMLID_2_"
                    className="st1"
                    d="M126.1,17.8c0,2.1-0.6,2.8-4,2.8h-9.3c-2.8,0-4-1-4-3.6V9.7c0-2.5,1.2-3.6,4-3.6h9.2 c2.6,0,3.9,0.3,3.9,2.9v1.5h3.5V8.2c0-2.5-1.2-5.4-6.7-5.4h-10.1c-5.3,0-7.5,2.4-7.5,7.9V16c0,5.6,2.2,7.9,7.5,7.9h10 c6,0,7.2-2.3,7.2-6V16h-3.7V17.8z"
                  />
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
    );
  }
}
